import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { switchMap } from 'rxjs';

export const authenticationInterceptor: HttpInterceptorFn = (req, next) => {
  const authenticationService = inject(AuthenticationService);
  return authenticationService.getCurrentSession().pipe(
    switchMap((v) => {
      const jwt = v.tokens?.idToken ?? v.tokens?.accessToken;
      if (
        req.url.match(/.s3.eu-central-1.amazonaws.com/) !== null
      ) {
        return next(req.clone());
      } else {
        if (!jwt) {
          // Don't send an invalid Authorization header.
          return next(req.clone());
        }
        const authReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${jwt.toString()}`,
          },
        });
        return next(authReq);
      }
    })
  );
};
